import { Form } from "antd";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";
import { SitesContractsTable } from "./SitesContractsTable";

export const SitesContractsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <SitesContractsTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
